import * as actions from './actions';

export type State = {
  currentView: string;
  pageStack: Array<string>;
  overridenAccountsData?: Array<Record<string, any>>;
  tempScenario: Record<string, any>;
  modelledScenario: Record<string, any>;
  selectedAccount: Record<string, any>;
  accountHolderOptions: Array<Record<string, string>>;
};

const initialState = {
  currentView: '',
  pageStack: [],
  tempScenario: {},
  modelledScenario: {},
  selectedAccount: {},
  accountHolderOptions: [],
};

export default (state: State = initialState, action: any = {}): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_ACCOUNTS:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
      };
    case actions.SET_ACCOUNT_HOLDER_OPTIONS:
      return {
        ...state,
        ...action.payload,
      };
    case actions.SET_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.payload,
      };
    case actions.UPDATE_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccount: {
          ...state.selectedAccount,
          ...action.payload,
        },
      };
    case actions.CURRENT_VIEW:
      if (state.currentView && action.payload) {
        state.pageStack.push(state.currentView);
      }
      const currentView = action.payload ? action.payload : state.pageStack.length ? state.pageStack.pop() : '';
      return {
        ...state,
        currentView,
      };
    case actions.CLEAN_UP:
      return {
        ...state,
        currentView: '',
        pageStack: [],
      };
    case actions.UPDATE_ACCOUNTS_DATA:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
      };
    case actions.OVERRIDE_ACCOUNTS_DATA:
      return {
        ...state,
        overridenAccountsData: action.payload,
      };
    default:
      return state;
  }
};
